
import Client from "../../../shared/Client";
import Vue, { PropType } from "vue";

export default Vue.extend({
    name: "ClientInfo",
    props: {
        client: {
            type: Object as PropType<Client>,
        },
        isEditable: Boolean,
    },
    computed: {
        disabled: {
            cache: false,
            get(): boolean {
                return !this.isEditable;
            }
        }
    },
    methods: {
        change() {
            this.$emit("change");
        }
    }
});
